// Loaded nodes and search results retain their data, but selection rules belong
// to the current chooser props (for example, the preceding workflow step).
export function withCurrentAssetGroupSelection(nodes, organizerSelection, selectableIf, checkableIf) {
    return nodes.map(node => {
        const group = node.assetGroup;
        return {
            ...node,
            ...(group ? {
                selectable: (!group.organizer || !!organizerSelection) && (!selectableIf || selectableIf(group)),
                checkable: !checkableIf || checkableIf(group),
            } : {}),
            ...(node.children ? {
                children: withCurrentAssetGroupSelection(node.children, organizerSelection, selectableIf, checkableIf),
            } : {}),
        };
    });
}
